import React from 'react';
import { getMatchLevelFAR, getMatchLevelColor, getMatchLevelDescription } from '@/utils/matchLevel';

interface MatchLevelBadgeProps {
  matchLevel: number;
  className?: string;
  showDescription?: boolean;
}

/**
 * Badge component for displaying FaceTec match level with FAR formatting
 * Shows security confidence level with appropriate color coding
 */
export const MatchLevelBadge: React.FC<MatchLevelBadgeProps> = ({ 
  matchLevel, 
  className = '',
  showDescription = false
}) => {
  const farText = getMatchLevelFAR(matchLevel);
  const colorClasses = getMatchLevelColor(matchLevel);
  const description = getMatchLevelDescription(matchLevel);
  
  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${colorClasses} ${className}`}>
      <span className="text-xs font-medium mr-1">Match Level:</span>
      <span className="font-semibold">{farText}</span>
      {showDescription && (
        <span className="ml-1 opacity-75">({description})</span>
      )}
    </div>
  );
};

export default MatchLevelBadge;
